/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total with tip`)
};

const es_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total con propina`)
};

const de_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtbetrag mit Trinkgeld`)
};

const nl_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal met fooi`)
};

const fr_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total avec pourboire`)
};

const it_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale con mancia`)
};

const pt_br2_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total com gorjeta`)
};

const pt_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total com gorjeta`)
};

const ja_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チップ込み合計`)
};

const zh_pct_result_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含小费总额`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_result_total = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_result_total(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_result_total", locale)
	if (locale === "en") return en_pct_result_total(inputs)
	if (locale === "es") return es_pct_result_total(inputs)
	if (locale === "de") return de_pct_result_total(inputs)
	if (locale === "nl") return nl_pct_result_total(inputs)
	if (locale === "fr") return fr_pct_result_total(inputs)
	if (locale === "it") return it_pct_result_total(inputs)
	if (locale === "pt-BR") return pt_br2_pct_result_total(inputs)
	if (locale === "pt") return pt_pct_result_total(inputs)
	if (locale === "ja") return ja_pct_result_total(inputs)
	return zh_pct_result_total(inputs)
};